import { render, staticRenderFns } from "./AgentMessageBubble.vue?vue&type=template&id=331bad99&scoped=true&"
import script from "./AgentMessageBubble.vue?vue&type=script&lang=js&"
export * from "./AgentMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./AgentMessageBubble.vue?vue&type=style&index=0&id=331bad99&scoped=true&lang=css&"
import style1 from "./AgentMessageBubble.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331bad99",
  null
  
)

export default component.exports